<template>
    <div class="news-page ignore-page">
      <car-header></car-header>
      <div class="ignore-banner" :style="{backgroundImage: `url(${newsBgImg})`}"></div>
      <div class="ignore-content-wrapper">
        <div class="news-title ignore-section-title">新闻中心</div>
        <div class="news-list">
          <news-item
            v-for="item in newsList"
            class="item"
            :key="item.id"
            :title="item.title"
            :cover="item.cover"
            :url="item.url"
            tag="大事记"
            :date="item.ctime"></news-item>
        </div>
      </div>
      <car-footer></car-footer>
    </div>
</template>

<script>
import carHeader from '../../components/header';
import carFooter from '../../components/footer';
import newsItem from '../../components/news-item';
import axios from 'axios';

export default {
  components: {
    carHeader,
    carFooter,
    newsItem
  },
  data () {
    return {
      newsBgImg: process.env.BASE_URL + 'news-bg.jpeg',
      newsList: []
    };
  },
  async created () {
    let res = await axios.get('/web/news/');
    if (res.status === 200) {
      this.newsList = res.data.results;
    }
  }
};
</script>

<style lang="scss" scoped>
.news-page {
  .news-title {
    margin: 40px 0;
  }

  .news-list {
    margin-bottom: 60px;

    .item {
      margin-bottom: 25px;
    }
  }
}
</style>
